(() => {
    const section = document.querySelector('[data-mission-section]');
    if (!section) return;
    const button = section.querySelector('[data-mission-toggle]');
    const items = [...section.querySelectorAll('[data-mission-item]')];
    if (!button || items.length <= 8) return;
    const remaining = items.slice(8);
    const label = button.querySelector('[data-mission-toggle-label]');
    const icon = button.querySelector('[data-mission-toggle-icon]');
    const setExpanded = (expanded) => {
        remaining.forEach((item) => { item.hidden = !expanded; });
        button.setAttribute('aria-expanded', String(expanded));
        label.textContent = expanded ? 'Tutup Misi' : 'Lihat Semua Misi';
        icon.className = expanded ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line';
    };
    setExpanded(false);
    button.hidden = false;
    button.addEventListener('click', () => setExpanded(button.getAttribute('aria-expanded') !== 'true'));
})();
